import { ITab } from "@koomzo/coremodel";
import {
  Component,
  OnInit,
  Renderer2,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { NavController, MenuController } from "@ionic/angular";
@Component({
  templateUrl: "./layout.page.html",
  styleUrls: ["./layout.page.scss"],
})
export class LayoutPage implements OnInit {
  tabList: ITab[];

  constructor(private menu: MenuController, private navCtrl: NavController) {}

  onIonTabChange(event) {
    console.log("iontab changed", event);
  }

  ngOnInit() {
    // this._store.dispatch(new LoadContentCategoryList());
    console.log("website nav created");
    this.tabList = [
      {
        label: "Home",
        path: "home",
        icon: "home-outline",
        iconActive: "home",
        displayOrder: 1,
      },
      {
        label: "Services",
        path: "service",
        icon: "server-outline",
        iconActive: "server",
        displayOrder: 2,
      },
      {
        label: "Products",
        path: "products",
        icon: "library-outline",
        iconActive: "library",
        displayOrder: 2,
      },
      // {
      //   label: 'Features',
      //   path: 'features',
      //   icon: 'paw',
      //   displayOrder: 2,
      // },
      // {
      //   label: "How It works",
      //   path: "how-it-works",
      //   icon: "hourglass-outline",
      //   iconActive: "hourglass",
      //   displayOrder: 3,
      // },
      {
        label: "About",
        path: "about-us",
        icon: "information-circle-outline",
        iconActive: "information-circle",
        displayOrder: 4,
      },
      {
        label: "Contact us.",
        path: "contact-us",
        icon: "location-outline",
        iconActive: "location",
        displayOrder: 4,
      },
      // {
      //   label: 'login',
      //   path: 'login',
      //   icon: 'log-in',
      //   displayOrder: 5,
      // },
      // {
      //   label: 'Signup.',
      //   path: 'provider-signup',
      //   icon: 'log-out',
      //   displayOrder: 6,
      // },

      // ,
      // {
      //   label: 'provider',
      //   path: 'provider-signup',
      //   icon: 'log-out',
      //   displayOrder: 7
      // }
    ];
  }

  public goToLogin() {
    //this.navCtrl.navigateForward('/web/login');
  }
}
